import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopConfigurationCourierActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/Courier/CourierBrowser")
	}

	render() {
		return (
			<Activity 
				name="Courier"
				RenderedComponent={this.RenderedComponent}
				context="Courier"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopConfigurationCourierActivity)
